const trustPoints = [
  { icon: 'ri-verified-badge-line', title: 'Professionally Managed', desc: 'All properties are managed by our experienced team, ensuring high standards of maintenance and service.' },
  { icon: 'ri-shield-check-line', title: 'Safe & Secure', desc: 'Properties are carefully vetted and regularly inspected for safety, cleanliness, and habitability.' },
  { icon: 'ri-file-text-line', title: 'Clear Tenancy Agreements', desc: 'Transparent lease terms with no hidden fees. Everything is laid out clearly before you sign.' },
  { icon: 'ri-customer-service-2-line', title: 'Responsive Support', desc: 'Our team responds to maintenance requests and queries promptly — your comfort is our priority.' },
];

export default function TrustBar() {
  return (
    <section className="py-16" style={{ background: 'rgb(246, 248, 252)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-8 h-0.5 bg-gold-500" />
            <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">Why Trust Galaxy Housing</span>
            <div className="w-8 h-0.5 bg-gold-500" />
          </div>
          <h2 className="font-heading text-3xl font-bold text-navy-800">
            Renting With Confidence
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustPoints.map((t) => (
            <div key={t.title} className="bg-white rounded-lg p-6 border border-navy-100 text-center">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-navy-800 text-gold-400 mx-auto mb-4">
                <i className={`${t.icon} text-lg`} />
              </div>
              <h3 className="font-semibold text-navy-800 text-sm mb-2">{t.title}</h3>
              <p className="text-navy-700/55 text-sm leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
